import LoadingAnimation from './loadingAnimation'
export default LoadingAnimation;